import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useEffect, useState } from "react";
import Navbar from "./components/Navbar";
import NewsletterForm from "./components/NewsletterForm";
import NewsletterList from "./components/NewsletterList";
import ReadNewsletters from "./components/ReadNewsletters";
import "./styles.css";

const API_URL = "https://enewsletter.onrender.com";

function App() {
  const [dark, setDark] = useState(false);
  const [newsletters, setNewsletters] = useState([]);

  const fetchNewsletters = async () => {
  const res = await fetch(`${API_URL}/api/newsletters`);
  const data = await res.json();
  setNewsletters(data);
};

  useEffect(() => {
    fetchNewsletters();
  }, []);

  return (
    <BrowserRouter>
      <div className={dark ? "app dark" : "app light"}>
        <Navbar dark={dark} toggleTheme={() => setDark(!dark)} />

        <div className="container">
          <Routes>
            <Route
              path="/"
              element={<NewsletterForm onCreated={fetchNewsletters} />}
            />
            <Route
              path="/list"
              element={<NewsletterList items={newsletters} />}
            />
            <Route path="/read" element={<ReadNewsletters />} />
          </Routes>
        </div>
      </div>
    </BrowserRouter>
  );
}

export default App;
